import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import RecoverPasswordForm from "../../../components/recoverPassword/RecoverPasswordForm";
import { changePassword, getEmailByRecoveryHash } from "../../../api/repositoryEP";
import LoadingDataComponent from "../../../components/common/LoadingData/LoadingDataComponent";
import { useAppConfig } from "../../../Contexts/AppConfigContext";



const RecoverPasswordPage = (): JSX.Element => {
    const { token } = useParams<{ token: string }>();
    const { t } = useTranslation();


    const [isLoading,setIsLoading] = useState<boolean>(false);
    const [email,setEmail] = useState<string>("");
    const [isLookingForEmail,setIsLookingForEmail] = useState<boolean>(false);
    const [expiredToken,setExpiredToken] = useState<boolean>(false);



    const recoverPassword = (email : string, password : string) : void => {
        setIsLoading(true);
        changePassword(email,password,token ?? "").then((r)=>{
            if (r?.type === 1){
                // redirigimos a la pagina de inicio
                setTimeout(()=>{window.location.href = "/";},2000);
            }
    }).finally(()=>{
            setIsLoading(false);
            
        })
    }

    useEffect(()=>{
        if(token){
            setIsLookingForEmail(true);
            getEmailByRecoveryHash(token).then((r)=>{
                if (r?.type === 1){
                    setEmail(r?.data);
                }else{
                    setExpiredToken(true);
                    //esperemos 5 segundos y redirijamos a la pagina de login
                    setTimeout(()=>{window.location.href = "/";},5000);
                  

                }
                setIsLookingForEmail(false);

            }
    )}
    },[token])

   

    return (
        <div className="contact-page">
            <h3 className="app-main-title">{t('pages.recover-password.title')}</h3>

            {email && (
                 <RecoverPasswordForm email={email} onFinish={recoverPassword} isLoading={isLoading} />

            )}

            {isLookingForEmail && <LoadingDataComponent/>}
            {(expiredToken  && !isLookingForEmail )&& (
                <div className="expired-token-message">
                    <p style={{textAlign:"center"}}>{t('pages.recover-password.expired-token')}</p>
                </div>
            )}
          



        </div>
    )
}

export default RecoverPasswordPage;